import { NotificationsManager } from "@core/managers/notifications.manager";
import { PaymentService } from "@core/services";
import { JavascriptHelpers } from "@core/helpers";

import { PAYMENT_TYPES, PAYMENT_RESPONSE } from "@core/constants";
import { CardsCollectionModel } from "@core/models";

export const paymentMixin = {
  methods: {
    async $_payWithCard({ cardId, demandId, extraId, upfront }) {
      const paymentToken = cardId;
      const type = PAYMENT_TYPES.FROM_SAVED_METHOD;
      return PaymentService.handlePayment({ demandId, paymentToken, type, extraId, upfront });
    },
    async $_payWithCredits({ demandId, extraId }) {
      return PaymentService.payWithCredits({ demandId, extraId });
    },
    async $_selectFavorite({ demandId, extraId }) {
      return PaymentService.selectFavorite({ demandId, extraId });
    },
    async $_unlockWithSubscription({ demandId, extraId }) {
      return PaymentService.unlockWithSubscription({ demandId, extraId });
    },
    async $_getSavedCards() {
      const cards = await PaymentService.getCards();
      return new CardsCollectionModel({ cards });
    },
    $_handlePaymentError({ error = {} }) {
      const { message, name, type, response } = error;

      // let the VALIDATION_ERROR fail silently, it's displayed on screen
      if (type === PAYMENT_RESPONSE.VALIDATION_ERROR) {
        return;
      }

      // let the INTEGRATION_ERROR fail silently (it means the user pressed the button too fast)
      if (name === PAYMENT_RESPONSE.INTEGRATION_ERROR) {
        return;
      }

      if (response && response.status === 400) {
        const responseMessage = this.$_getSanitizedResponseMessage(response);
        if (responseMessage) {
          NotificationsManager.error({ message: responseMessage });
          return;
        }
        NotificationsManager.contactEtabSupport();
        return;
      }

      if (message) {
        NotificationsManager.error({ message });
        return;
      }
      NotificationsManager.contactEtabSupport();
    },
    $_getSanitizedResponseMessage(response) {
      const message = response && response.data && response.data.message;
      if (message) {
        return JavascriptHelpers.containsHTML(message) ? undefined : message;
      }
      return undefined;
    },
  },
};
